// api/Aula/AcademicCompetenciesService.ts
import client from "../Client/HttpClient";
import { IAcademicCompetenciesModel } from "@/interfaces/modules";

const ApiPath = "AcademicCompetencies";

export default {
    GetAcademicCompetencies: (): Promise<IAcademicCompetenciesModel[]> => client.get(`${ApiPath}`),
    GetAcademicCompetenciesById: (data: IAcademicCompetenciesModel): Promise<IAcademicCompetenciesModel> => client.get(`${ApiPath}/${data.Id}`),
    PostAcademicCompetencies: (data: IAcademicCompetenciesModel): Promise<IAcademicCompetenciesModel> =>client.post(`${ApiPath}`, data),
};
